import { useMemo } from "react";
import useCurrentIdentity from "utilities/hooks/use-current-identity";

const useUserUploadId = () => {
    const { currentIdentity } = useCurrentIdentity();

    const userUploadId = useMemo(() => {
        return (
            currentIdentity?.user?.netsuiteId?.toString() ??
            `L_${currentIdentity?.user?.id}`
        );
    }, [currentIdentity]);

    return { userUploadId };
};
export default useUserUploadId;
